/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeploymentFreshnessSlackMessageRequest} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'
import {DeploymentFreshnessSlackMessageResponse} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'


export const deploymentFreshnessSlackMessage = (request: DeploymentFreshnessSlackMessageRequest, options?: CashRequestOptions) => post<DeploymentFreshnessSlackMessageRequest, DeploymentFreshnessSlackMessageResponse>("/2.0/cash/deployment-freshness-slack-message", request, {...options, rejectOnError: true })